import React from 'react';
import PropTypes from 'prop-types';
import { LOGIN_STEP as LS } from 'state/login/types';
import { LoginButton } from './EducatorPin';
import ClearPinBtn from './ClearPinBtn';
import Header from './Header';
import common from '../style/common.module.scss';
import style from '../style/StudentPinPassword.module.scss';
import styleStudentPin from '../style/StudentPin.module.scss';
import { translate } from '@lwtears/lwt-common-frontend/lib/@common/util/i18n-util';

const t = (key) => translate('common', key);

class StudentPinPassword extends React.Component {
  constructor(props) {
    super(props);

    const { users, selectedUserId } = props;
    const { login, username } = users.find((user) => user.id === selectedUserId);
    this.passwordInputRef = React.createRef();

    this.state = {
      password: '',
      username,
      login
    };
  }
  componentDidMount() {
    this.passwordInputRef.current.focus();
  }

  componentDidUpdate(prevProps) {
    const prevError = prevProps.error || {};
    const currentError = this.props.error || {};
    const currentSuccess = this.props.success;

    if (!currentSuccess && prevError.id !== currentError.id) {
      this.setState({ password: '' });
    }
  }

  loginStudent = () => {
    this.props.loginUser(
      this.props.selectedUserId,
      this.state.password,
      this.props.selectedClassId
    );
  };

  updatePassword = (e) => this.setState({ password: e.target.value.toUpperCase() });

  announceStudentPinEvent(message) {
    const el = document.getElementById('assistiveStudentPinAnnouncements');

    if (!el) return;

    el.innerText = '';

    setTimeout(() => {
      el.innerText = message;
    }, 500);
  }

  onPinCleanUp = () => {
    const { clearLoginError } = this.props;
    this.updatePassword({ target: { value: '' } });
    this.announceStudentPinEvent('User secret code has been cleared');
    clearLoginError();
  };

  handleEnter = (e) => {
    // eslint-disable-next-line
    if (e.charCode == '13') {
      this.props.loginUser(
        this.props.selectedUserId,
        this.state.password,
        this.props.selectedClassId
      );
      e.preventDefault();
    }
  };
  render() {
    const { goToStep, error, contentScaling, success, loading } = this.props;
    const { password } = this.state;

    return (
      <div className={common.selectPage}>
        <Header message={this.state.username} previousStep={LS.SHOW_USERS} goToStep={goToStep} />
        <div
          className={[
            common.content,
            common[`content${contentScaling}`],
            common.contentCenter
          ].join(' ')}
        >
          <h2
            className={[common.heading, common[`heading${contentScaling}`]].join(' ')}
            id="secretCodeTextBox"
          >
            {`${this.state.username}, ${t('EnterYourSecretCode')}`}
          </h2>
          <article
            aria-live="polite"
            className={styleStudentPin.assistiveStudentPinAnnouncements}
            id="assistiveStudentPinAnnouncements"
            role="region"
          ></article>
          <div className={[style.formContainer, style[`formContainer${contentScaling}`]].join(' ')}>
            <input
              aria-labelledby="secretCodeTextBox"
              placeholder={t('EnterYourSecretCode')}
              value={this.state.password}
              aria-describedby={t('EnterYourSecretCode')}
              onChange={this.updatePassword}
              onKeyPress={this.handleEnter}
              className={[style.password, style[`password${contentScaling}`]].join(' ')}
              ref={this.passwordInputRef}
              id="secret-code-text-box"
            />
            <div className={styleStudentPin.clearPassword}>
              <ClearPinBtn contentScaling={contentScaling} onClick={this.onPinCleanUp} />
            </div>
            {!error && !loading && !success && <div style={{ height: '43px' }}></div>}
            {loading && (
              <div style={{ height: '35px' }}>
                <div className="loader"></div>
              </div>
            )}
            {error && !loading && !success && (
              <p
                aria-live="assertive"
                className={[style.error, style[`error${contentScaling}`]].join(' ')}
                role="alert"
              >
                {t(error.message)}
              </p>
            )}
            {success && !error && !loading && (
              <p
                aria-live="assertive"
                className={[style.success, style[`success${contentScaling}`]].join(' ')}
                role="alert"
              >
                {t(success.message)}
              </p>
            )}
            <LoginButton
              contentScaling={contentScaling}
              disabled={!password}
              onClick={this.loginStudent}
              styles={style}
            />
          </div>
        </div>
      </div>
    );
  }
}

StudentPinPassword.propTypes = {
  users: PropTypes.array,
  selectedClassId: PropTypes.number,
  selectedUserId: PropTypes.number,
  error: PropTypes.object,
  success: PropTypes.object,
  loginUser: PropTypes.func,
  goToStep: PropTypes.func,
  contentScaling: PropTypes.number
};

export default StudentPinPassword;
